import { Section1 } from "./component/Section1";
import { Section2 } from "./component/Section2";
import { Section3 } from "./component/Section3";
import { Section4 } from "./component/Section4";
import { Section5 } from "./component/Section5";
import { Section6 } from "./component/Section6";
import { Section7 } from "./component/Section7";
import { Section8 } from "./component/Section8";
import { useResponsiveMobile } from "../../hooks/useResponsiveMobile";
import { useEffect } from "react";
import { setDescription } from "../../seo/seo";
import Button from "../../component/Button";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const isMobile = useResponsiveMobile();
  useEffect(() => {
    document.title = "품(Poom) | 분산된 결제를 하나로, 통합 정산 관리";
    setDescription(
      "결제 정산 운영 이젠 어렵지 않아요 - 품으로 비즈니스에 딱 필요한 정산 업무 핵심기능부터 파트너 전용 서비스까지 한번에 사용해보세요 ",
    );
  }, []);
  return (
    <div className="w-full flex flex-col relative">
      <div className="relative isolate w-full flex justify-center overflow-hidden md:pt-[180px]">
        {/* 배경을 img로 */}
        <img
          src={
            isMobile
              ? "/assets/images/home/gradient_mobile.webp"
              : "/assets/images/home/gradient.webp"
          }
          alt=""
          aria-hidden="true"
          fetchPriority="high"
          loading="eager"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* 아래쪽 연결 페이드(원하면 켜기) */}
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[100px] md:h-[140px] bg-gradient-to-b from-white/0 to-white" />

        {/* 텍스트 레이어(중앙 정렬, 마진 제거) */}
        {isMobile ? (
          <div className="relative z-10 flex flex-col h-full pt-[116px]  text-center w-full px-4">
            <div className="flex flex-col gap-[60px]">
              <div className="flex flex-col gap-6">
                <h1
                  className="font-bold text-[clamp(32px,6vw,48px)] leading-[1.15] text-white"
                  style={{ fontFamily: "NexonLv1Gothic" }}
                >
                  결제부터 정산까지, <br /> 품이 만드는
                  <br />
                  가장 쉬운 관리
                </h1>
                <span className="font-normal text-[clamp(16px,3.2vw,24px)] leading-[1.6] text-white">
                  비용이 많이 드는 서버 구축 없이, 품은 바로 시작할 수 있는 통합 결제·정산 관리
                  서비스입니다. 비즈니스에 유연함과 정확성을 더해보세요.
                </span>
              </div>
            </div>
            <img src="/assets/images/home/bg_eg_mobile.png" alt="eg" className="w-full h-auto" />
          </div>
        ) : (
          <div className="relative z-10 flex flex-col items-center px-6 text-center">
            <div className="flex flex-col gap-8 items-center">
              <div className="flex flex-col gap-8">
                <h1
                  className="font-bold text-[clamp(46px,6vw,72px)] leading-[1.2] text-white"
                  style={{ fontFamily: "NexonLv1Gothic", letterSpacing: "-2.88px" }}
                >
                  <span className="glass-text glass-text--sparkle" data-text="결제">
                    결제
                  </span>
                  <span className="" style={{ fontWeight: 500 }}>
                    부터{" "}
                  </span>
                  <span className="glass-text glass-text--sparkle" data-text="정산">
                    정산
                  </span>
                  <span className="" style={{ fontWeight: 500 }}>
                    까지
                  </span>
                  ,
                  <br /> 품
                  <span className="" style={{ fontWeight: 500 }}>
                    이 만드는
                  </span>{" "}
                  가장 쉬운 관리
                </h1>
                <p className="font-normal text-[clamp(14px,2.2vw,24px)] leading-[1.4] text-white [text-shadow:0_2px_8px_rgba(0,0,0,0.45)]">
                  비용이 많이 드는 서버 구축 없이, 품은 바로 시작할 수 있는 통합 결제·정산 관리
                  서비스입니다. <br />
                  비즈니스에 유연함과 정확성을 더해보세요.
                </p>
              </div>
            </div>
            <div className="relative w-full max-w-[1680px]">
              {!isMobile && (
                <img
                  src="/assets/images/home/bubble.webp"
                  alt="eg"
                  fetchPriority="high"
                  className="pointer-events-none w-[25vw] max-w-[546px] h-auto absolute top-[-30%] right-[0%]"
                  style={{ zIndex: -99 }}
                />
              )}
              <img
                src="/assets/images/home/bg_eg.webp"
                alt="eg"
                className="relative z-10 w-full h-auto"
              />
            </div>
          </div>
        )}
      </div>

      <Section1 />
      <Section2 />
      <Section3 />

      <Section4 />

      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
    </div>
  );
};

export default Home;
